import axios from 'axios';
import { AuthResult } from '../models/AuthResult';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../utils/Constants';
import { removeSessionInfo } from '../utils/StorageUtils';

export const baseURL = `${__JS_ENV_VARS__['JS_ENV_API_BASE_URL']}/api`;

const refreshTokenAxios = axios.create({ baseURL, method: 'POST' });

const doRefreshToken = async (): Promise<AuthResult> => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  const { data } = await refreshTokenAxios.request<AuthResult>({
    url: '/user/refresh-token',
    headers: { Authorization: `Bearer ${accessToken}` },
    data: { refresh_token: refreshToken, app_version: '1.2.1' },
  });
  return data;
};

let refreshTokenPromise: Promise<AuthResult> | null = null;
export const refreshToken = () => {
  if (refreshTokenPromise == null) {
    refreshTokenPromise = doRefreshToken()
      .then((auth) => {
        localStorage.setItem(ACCESS_TOKEN, auth.access_token);
        localStorage.setItem(REFRESH_TOKEN, auth.refresh_token);
        refreshTokenPromise = null;
        return auth;
      })
      .catch((e) => {
        removeSessionInfo();
        document
          .getElementById('app-root')
          ?.dispatchEvent(new Event('auth-error'));
        throw e;
      });
  }
  return refreshTokenPromise;
};
